import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import FoundryButton from "./foundry/FoundryButton";

// Bundle the worker locally; invoice content never goes to a CDN.
pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

export default function InvoicePdfPreview({ url }: { url: string }) {
  const container = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(750);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  useEffect(() => {
    const node = container.current;
    if (!node) return;
    const resize = () => setWidth(Math.max(200, Math.min(1000, Math.floor(node.clientWidth) - 32)));
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <div title="Inkoopfactuur PDF" className="flex min-h-0 flex-1 flex-col">
    <div ref={container} className="min-h-0 flex-1 overflow-auto bg-slate-100 p-4 dark:bg-slate-950">
      <Document file={url} onLoadSuccess={({ numPages }) => setPages(numPages)}
        loading={<p role="status" className="text-sm text-slate-500">PDF laden...</p>}
        error={<p role="alert" className="text-sm text-red-700 dark:text-red-300">De PDF kon niet worden weergegeven. Je kunt het document wel downloaden.</p>}
        className="mx-auto w-fit">
        <Page pageNumber={page} width={width} renderTextLayer={false} renderAnnotationLayer={false}
          loading={<p role="status">Pagina laden...</p>}
          error={<p role="alert">Deze pagina kon niet worden weergegeven.</p>} />
      </Document>
    </div>
    {pages > 1 && <div className="flex items-center justify-center gap-4 border-t border-slate-200 px-4 py-2 text-xs dark:border-white/10">
      <FoundryButton type="button" onClick={() => setPage((current) => current - 1)} disabled={page <= 1}>Vorige pagina</FoundryButton>
      <span role="status">Pagina {page} van {pages}</span>
      <FoundryButton type="button" onClick={() => setPage((current) => current + 1)} disabled={page >= pages}>Volgende pagina</FoundryButton>
    </div>}
  </div>;
}
